export default "__VITE_ASSET__Dhv$5kCb__"